import { render, staticRenderFns } from "./commissionPercentageDialog.vue?vue&type=template&id=cfcc0f44&scoped=true"
import script from "./commissionPercentageDialog.vue?vue&type=script&lang=ts"
export * from "./commissionPercentageDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfcc0f44",
  null
  
)

export default component.exports